
import Form from './Form.vue'
import { useStore } from 'vuex'
import { defineComponent, ref, onMounted, computed, toRefs, reactive } from 'vue'

export default defineComponent({
  components: {
    Form
  },
  setup () {
    const form = reactive({
      id: '',
      name: '',
      description: '',
      view: ''
    })
    const modal_form = ref<InstanceType<typeof Form>>()
    const form_action = ref('save')
    const visible = ref(false)
    const store = useStore()

    const fields = ref([
      {
        title: 'Role Name',
        dataIndex: 'name',
      },
      // {
      //   title: "Is Active",
      //   dataIndex: "is_active",
      //   align: 'center',
      //   slots: { customRender: "is_active" }
      // },
      {
        title: 'Action',
        dataIndex: 'action',
        slots: {customRender: 'action'},
        align: 'center'
      },
    ])

    const index = (payload = {page: 1}) => {
      store.dispatch('Role/index', payload)
    }

    const editRecord = (record: any) => {
      form_action.value = 'update'
      const {id, name, view} = toRefs(form)
      id.value = record.id
      name.value = record.name
      view.value = record.view
      visible.value = true
    }

    const createRecord = () => {
      form_action.value = 'save'
      const {name, view} = toRefs(form)
      name.value = ''
      view.value = ''
      visible.value = true
    }

    const deleteRecord = (record: any) => {
      store.dispatch('Role/destroy', record.id)
    }

    const handleSaving = (record: any) => {
      form_action.value == 'save' ? storeRecord(record) : updateRecord(record)
    }

    const storeRecord = (payload: any) => {
      payload.description = payload.name
      modal_form.value?.setLoading(true)
      store
          .dispatch('Role/store', payload)
          .then(() => (visible.value = false))
          .finally(() => modal_form.value?.setLoading(false))
    }

    const updateRecord = (payload: any) => {
      payload.description = payload.name
      store
          .dispatch('Role/update', payload)
          .then(() => (visible.value = false))
    }

    const filterRecord = (payload: any) => {
      index(payload)
    }

    const items = computed(() => store.getters['Role/items'])
    const loading = computed(() => store.getters['Role/status'])

    onMounted(index)

    return {
      loading,
      items,
      fields,
      visible,
      form,
      modal_form,
      editRecord,
      deleteRecord,
      storeRecord,
      createRecord,
      updateRecord,
      handleSaving,
      filterRecord
    }
  },
})
